export const Capitalize = (val) => {
  return val?.charAt(0)?.toUpperCase() + val?.slice(1)?.replace(/_/g, " ");
};
